import { createPortal } from 'react-dom';
import WorkspaceLoadingScreen from '../../../components/loading/workspace/WorkspaceLoadingScreen';
import { IMPERSONATION_ENTER_STAGES, IMPERSONATION_EXIT_STAGES } from '../../../impersonation/exit/impersonationExit';
import useHandoffStages from '../../../impersonation/exit/useHandoffStages';

const ImpersonationStartOverlay = ({
  phase = 'starting',
  message = 'Signing into this account...',
  detail,
}) => {
  const exiting = phase === 'ending';
  const stagedMessage = useHandoffStages(
    exiting ? IMPERSONATION_EXIT_STAGES : IMPERSONATION_ENTER_STAGES,
    true
  );
  const displayMessage = stagedMessage || message;

  if (typeof document === 'undefined') return null;

  return createPortal(
    <div style={{ position: 'fixed', inset: 0, zIndex: 20000 }}>
      <WorkspaceLoadingScreen
        message={displayMessage}
        detail={exiting ? 'Restoring your admin session' : detail}
      />
    </div>,
    document.body
  );
};

export default ImpersonationStartOverlay;
